import React, { createRef, useState } from 'react';
import Tooltip from '@components/tooltip';
import { CopyWrapper, CopyInput, StyledButton } from './copy.styled';
var Copy = function Copy(_ref) {
    var _ref$buttonLabel = _ref.buttonLabel, buttonLabel = _ref$buttonLabel === void 0 ? 'Copy' : _ref$buttonLabel, _ref$buttonWidth = _ref.buttonWidth, buttonWidth = _ref$buttonWidth === void 0 ? 4.12 : _ref$buttonWidth, copyText = _ref.copyText, _ref$copyLabel = _ref.copyLabel, copyLabel = _ref$copyLabel === void 0 ? 'Bookmark' : _ref$copyLabel, className = _ref.className;
    var _useState = useState(false), isCopied = _useState[0], setIsCopied = _useState[1];
    var input = /*#__PURE__*/ createRef();
    var handleButtonMouseLeave = function handleButtonMouseLeave() {
        setIsCopied(false);
    };
    var onCopyClick = function onCopyClick() {
        if (input.current) {
            setIsCopied(true);
            input.current.focus();
            input.current.select();
            document.execCommand('copy');
        }
    };
    var tooltipText = isCopied ? 'Copied!' : "Copy " + copyLabel;
    return /*#__PURE__*/ React.createElement(CopyWrapper, {
        className: className || '1'
    }, /*#__PURE__*/ React.createElement(CopyInput, {
        type: "text",
        ref: input,
        readOnly: true,
        value: copyText
    }), /*#__PURE__*/ React.createElement(Tooltip, {
        text: tooltipText,
        handleMouseLeave: handleButtonMouseLeave
    }, /*#__PURE__*/ React.createElement(StyledButton, {
        label: buttonLabel,
        width: buttonWidth,
        height: 2.25,
        onClick: onCopyClick
    })));
};
export default Copy;
